// @flow
export { default } from './InputTags';



// WEBPACK FOOTER //
// ./src/components/write/InputTags/index.js